import { render, staticRenderFns } from "./automodal.vue?vue&type=template&id=776d0b76&"
import script from "./automodal.vue?vue&type=script&lang=js&"
export * from "./automodal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports